module.exports = __webpack_public_path__ + "assets/295d354a7f7865caa75c192745ac68b47.jpg";